import "../../../Assets/Pwa/PwaInstall";
const root = location.protocol + '//' + location.host;

if(root.indexOf("localhost") === -1) {
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(root + "/serviceworker.js");
}

let releaseVersion = "v2";
let releaseVersionCheck;
//console.log(releaseVersion)
if(!localStorage.hasOwnProperty("releaseVersionCheck")) {
    localStorage.setItem("releaseVersionCheck","v0");
    releaseVersion = "v0";
}
else {
    releaseVersionCheck = localStorage.getItem("releaseVersionCheck");
    if(releaseVersion !== releaseVersionCheck) {
        localStorage.setItem("releaseVersionCheck", releaseVersion);
    }
}

const date = new Date();
const timeStampOfVisit = date.getTime();
const timeStampOfFirstVisit = localStorage.hasOwnProperty("visitTimeStamp") ? Number(localStorage.getItem("visitTimeStamp")) : timeStampOfVisit;
const twelveHours = 1000 * 60 * 60 * 12;
navigator.serviceWorker.ready.then((a) => {

    if(timeStampOfFirstVisit === timeStampOfVisit || timeStampOfVisit > twelveHours + timeStampOfFirstVisit) {
        localStorage.setItem("visitTimeStamp",String(timeStampOfVisit));
    }
    if(navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(releaseVersion + ';' + releaseVersionCheck + ';' + timeStampOfFirstVisit + ';' + timeStampOfVisit);
    }
});
}


